import { useEffect } from 'react'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { pickBy, first, keys } from 'lodash'

import useUserProperties from './useUserProperties'

const useIdentifyUserDeviceSize = () => {
  const setUserProperties = useUserProperties()
  const theme = useTheme()

  const mobile = useMediaQuery(theme.breakpoints.down('sm'))
  const tablet = useMediaQuery(theme.breakpoints.only('md'))
  const desktop = useMediaQuery(theme.breakpoints.up('lg'))

  const deviceSize = filterFirstTrueKey({ mobile, tablet, desktop })

  useEffect(() => {
    setUserProperties({ Device: deviceSize })
  }, [deviceSize]) //eslint-disable-line
}

export const filterFirstTrueKey = obj => first(keys(pickBy(obj)))

export default useIdentifyUserDeviceSize
